const products = [
  {
    id: 1,
    name: { tr: "Kavrulmuş Fındık", en: "Roasted Hazelnuts" },
    description: { tr: "Kuru kavrulmuş premium fındık.", en: "Dry roasted premium hazelnuts." },
    price: 12.99,
    currency: "USD",
    image: "/img/findik.png",
    stock: 120,
    category: "nuts"
  },
  {
    id: 2,
    name: { tr: "Çiğ Badem", en: "Raw Almonds" },
    description: { tr: "Doğal ve tuzsuz çiğ badem.", en: "Natural unsalted raw almonds." },
    price: 10.49,
    currency: "USD",
    image: "/img/badem.png",
    stock: 85,
    category: "nuts"
  },
  {
    id: 3,
    name: { tr: "Kavrulmuş Kaju", en: "Roasted Cashews" },
    description: { tr: "Hafif tuzlu kavrulmuş kaju.", en: "Lightly salted roasted cashews." },
    price: 14.99,
    currency: "USD",
    image: "/img/kaju.png",
    stock: 60,
    category: "nuts"
  },
  {
    id: 4,
    name: { tr: "Antep Fıstığı", en: "Pistachios" },
    description: { tr: "Kabuklu ve taze antep fıstığı.", en: "Fresh in-shell pistachios." },
    price: 18.99,
    currency: "USD",
    image: "/img/fistik.png",
    stock: 45,
    category: "nuts"
  },
  {
    id: 5,
    name: { tr: "Karışık Kuruyemiş", en: "Mixed Nuts" },
    description: { tr: "Özel harmanlanmış kuruyemiş karışımı.", en: "Specially blended mixed nuts." },
    price: 16.99,
    currency: "USD",
    image: "/img/mix.png",
    stock: 50,
    category: "nuts"
  },
  {
    id: 7,
    name: { tr: "Kuru Üzüm", en: "Raisins" },
    description: { tr: "Çekirdeksiz ve tatlı kuru üzüm.", en: "Seedless sweet raisins." },
    price: 7.99,
    currency: "USD",
    image: "/img/siyah.png",
    stock: 100,
    category: "driedFruits"
  },
  {
    id: 8,
    name: { tr: "Leblebi", en: "Roasted Chickpeas" },
    description: { tr: "Geleneksel beyaz leblebi.", en: "Traditional roasted chickpeas." },
    price: 5.99,
    currency: "USD",
    image: "/img/leblebi.png",
    stock: 150,
    category: "snacks"
  },
  {
    id: 9,
    name: { tr: "Kuru İncir", en: "Dried Figs" },
    description: { tr: "Doğal ve yumuşak kuru incir.", en: "Natural soft dried figs." },
    price: 11.99,
    currency: "USD",
    image: "/img/incir.png",
    stock: 55,
    category: "driedFruits"
  },
  {
    id: 10,
    name: { tr: "Yer Fıstığı", en: "Peanuts" },
    description: { tr: "Kavrulmuş ve tuzlu yer fıstığı.", en: "Roasted and salted peanuts." },
    price: 6.99,
    currency: "USD",
    image: "/img/antepfistigi.png",
    stock: 200,
    category: "nuts"
  }
];

const giftProducts = [
  {
    id: 11,
    name: { 
      tr: "Karışık Kuruyemiş & Çikolata Kutusu", 
      en: "Mixed Nuts & Chocolate Box" 
    },
    description: { 
      tr: "Karışık kuruyemiş ve özel çikolatalardan oluşan şık hediye kutusu.", 
      en: "Elegant gift box with mixed nuts and special chocolates." 
    },
    price: 1899,
    currency: "USD",
    image: "/img/gifts/mixkuruyemis.png",
    stock: 15,
    category: "gifts"
  },

  {
    id: 12,
    name: { 
      tr: "Karışık Kuruyemiş & Lokum Kutusu", 
      en: "Mixed Nuts & Turkish Delight Box" 
    },
    description: { 
      tr: "Seçkin kuruyemişler ve renkli lokum çeşitleriyle hazırlanmış hediye kutusu.", 
      en: "Gift box prepared with selected nuts and assorted Turkish delights." 
    },
    price: 1999,
    currency: "USD",
    image: "/img/gifts/mixlokum.png",
    stock: 12,
    category: "gifts"
  },

  {
    id: 13,
    name: { 
      tr: "Ahşap Kutuda Kuruyemiş & Lokum", 
      en: "Wooden Box Nuts & Turkish Delight" 
    },
    description: { 
      tr: "Ahşap bölmeli kutuda kuruyemiş ve lokum çeşitleri.", 
      en: "Assorted nuts and Turkish delights in a wooden compartment box." 
    },
    price: 1699,
    currency: "USD",
    image: "/img/gifts/lokumgift.png",
    stock: 18,
    category: "gifts"
  },

  {
    id: 14,
    name: { 
      tr: "Ahşap Kutuda Kuruyemiş & Kuru Meyve", 
      en: "Wooden Box Nuts & Dried Fruits" 
    },
    description: { 
      tr: "Kuruyemiş ve kuru meyvelerden oluşan doğal hediye kutusu.", 
      en: "Natural gift box with nuts and dried fruits." 
    },
    price: 1799,
    currency: "USD",
    image: "/img/gifts/cikolatagift.png",
    stock: 16,
    category: "gifts"
  }
];


export default products;
export { giftProducts };
